import {
  ExitIcon,
  PersonIcon,
  QuestionMarkCircledIcon,
} from '@radix-ui/react-icons';
import { Button, DropdownMenu, Flex, Skeleton } from '@radix-ui/themes';
import { QueryStatus } from '@reduxjs/toolkit/query';
import { useState } from 'react';
import { logout } from '@/entities/session';
import { useStaffMeQuery } from '@/shared/api';
import { useAppDispatch, useRedirectPath } from '@/shared/hooks';
import { appSession } from '@/shared/lib';

export function Header() {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { navigateToLoginAfterLogout } = useRedirectPath();
  const { data: staffMe, status } = useStaffMeQuery();

  return (
    <header className="border-y border-gray-200 flex justify-end min-h-12 h-12">
      <div className="flex gap-5 items-center px-5">
        <Button variant="ghost" color="gray">
          <QuestionMarkCircledIcon />
        </Button>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger>
            <Button variant="ghost" color="gray">
              <PersonIcon />
              <Skeleton
                loading={status === QueryStatus.pending}
                className="min-w-20 h-4"
              >
                {staffMe?.result.first_name} {staffMe?.result.last_name}
              </Skeleton>
            </Button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content>
            <DropdownMenu.Item
              asChild
              disabled={loading}
              onClick={() => {
                setLoading(true);
                dispatch(logout())
                  .unwrap()
                  .then(() => {
                    setLoading(false);
                    appSession.removeItem();
                    navigateToLoginAfterLogout();
                  });
              }}
            >
              <Flex gap="2">
                <ExitIcon /> Logout
              </Flex>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      </div>
    </header>
  );
}
